export interface IPageInfo {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalCount: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export const defaultPageInfo: IPageInfo = {
  currentPage: 0,
  totalPages: 0,
  pageSize: 20,
  totalCount: 0,
  hasPrevious: false,
  hasNext: false,
};
